export const changePasswordForm = {
    title: {
        changePassword: 'Change password',
    },
    message: {
        changePassword: 'You are required to change your password',
        success: 'Change password successfully',
    },
    currentPassword: {
        label: 'Current password',
        placeholder: 'Current password',
    },
    password: {
        label: 'Password',
        placeholder: 'Password',
    },
    confirmPassword: {
        label: 'Confirm password',
        placeholder: 'Confirm password',
    },
    error: {
        confirmPasswordDoNotMatch: 'Confirm password does not match',
        duplicatePassword: 'Password must be different from current password',
    },
};
